// teamManager.js

import { getTeamColor } from './teamColors.js';

class TeamManager {
    constructor() {
        this.teamMap = new Map();
        this.playerTeamMap = new Map();
        this.nextTeamId = 0;
    }

    assignTeam(players) {
        const playerArray = Array.isArray(players) ? players : [players];
        const teamId = this.nextTeamId++;

        playerArray.forEach(playerName => {
            this.playerTeamMap.set(playerName, teamId);
        });
        this.teamMap.set(teamId, playerArray);
    }

    getTeamId(playerName) {
        return this.playerTeamMap.get(playerName);
    }

    getTeamColor(playerName) {
        const teamId = this.getTeamId(playerName);
        return getTeamColor(teamId);
    }

    reset() {
        this.teamMap.clear();
        this.playerTeamMap.clear();
        this.nextTeamId = 0;
    }
}

export default new TeamManager();


// WEBPACK FOOTER //
// src/components/MatchPlayer/teamManager.js